module.exports = __webpack_public_path__ + "assets/arrow-9ee696.svg";